import { render, staticRenderFns } from "./yapay.vue?vue&type=template&id=4f61635a&"
import script from "./yapay.vue?vue&type=script&lang=js&"
export * from "./yapay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports